module.exports = __webpack_public_path__ + "img/day05.fd719b59.png";